import { motion, Variants } from "framer-motion";
import { useInView } from "react-intersection-observer";

interface FadeProps {
  direction?: VariantKey;
}

type VariantKey = keyof typeof variantMap;

const variantMap = {
  none: {
    opacity: 0,
  },
  t: {
    y: -40,
    opacity: 0,
  },
  r: {
    x: 40,
    opacity: 0,
  },
  b: {
    y: 40,
    opacity: 0,
  },
  l: {
    x: -40,
    opacity: 0,
  },
};

const variants: Variants = {
  inView: { opacity: 1, x: 0, y: 0 },
  hidden: (direction: VariantKey) => variantMap[direction],
};

export const Fade: React.FC<FadeProps> = ({ children, direction = "none" }) => {
  const { inView, ref } = useInView({ rootMargin: "0px 0px -15% 0px" });

  return (
    <div ref={ref}>
      <motion.div
        animate={inView ? "inView" : "hidden"}
        variants={variants}
        transition={{ duration: 0.4 }}
        custom={direction}
      >
        {children}
      </motion.div>
    </div>
  );
};
